import { z } from "zod";

export const ReminderSchema = z.object({
  id: z.int().positive().readonly(),
  description: z.string().nullable(),
  alert_date: z.iso.datetime().nullable(),
  status: z.string().min(1).readonly(),
  is_seen: z.boolean().nullish(),
  alert_type: z.int().min(1).max(14),
  alert_tag: z.string().nullable(),
  repeat_count: z.int().min(0).max(2147483647),
  recurring_interval: z.enum(["Never", "Daily", "Weekly", "Monthly", "Yearly"])
});
